import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, colors } from "@mui/material";
import CategoryHeader from "../../../../Components/Headers/CategoryHeader";
import Swal from "sweetalert2";
import axios from "axios";
import LoadingStatus from "../../../../Components/PolicyStatusComponents/LoadingStatus";
import {
  getLocalData,
  setLocalData,
} from "../../../../Utilities/Common/source";
import getTransferData from "./../../../CreateQuote/Helpers/getTransferData";
import { getDomain } from "../../../../Utilities/utils";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import axiosInstance from "../../../../Utilities/djangoAxiosInstance";
import expressAxiosInstance from "../../../../AcuvisorCustomerApp/utils/axiosInstance";

const PaymentStatusPage = () => {
  const [transactionData] = useSearchParams();
  const [policyStatus, setPolicyStatus] = useState("");
  const [transferData, setTransferData] = useState(null);
  const [transferDataId, setTransferDataId] = useState("");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isVerifyingKYC, setIsVerifyingKYC] = useState(false);

  const PaymentStatus = transactionData?.get("res");
  const sessionId = transactionData?.get("sessionId");
  console.log("sessionID on payment status", sessionId);
  let [policyNumber, setPolicyNumber] = useState(
    transactionData?.get("policyNumber") || "",
  );
  const localSource = transactionData?.get("source");
  console.log("localSource is this", localSource);
  const id = transactionData?.get("transferId");

  transactionData.forEach((ele) => console.log(ele));

  const isNext = PaymentStatus !== "success";

  useEffect(() => {
    let domain = getDomain();
    console.log("domain: ", domain);
    let status_check = "";
    // Check if localSource and id exist
    const hasLocalSourceAndId = localSource && id;
    if (PaymentStatus === "success") {
      status_check = true;
    } else {
      status_check = false;
    }
    expressAxiosInstance
      .get(`api/customer/common/fetch-temp-data`, {
        params: {
          policyNumber: policyNumber,
          verification_status: status_check,
          sessionId: sessionId,
        },
      })
      .then((response) => {
        console.log("tempresponse", response.data);
        if (!policyNumber) {
          policyNumber = response.data.CQ_response.policy_number;
        }
        let stateData = {
          policyNumber: policyNumber,
          paymentStatus: PaymentStatus,
          cqResponse: response?.data?.CQ_response,
        };
        if (response.data.CQ_response?.temp_data?.source === "b2c") {
          navigate(`/customer/health-insurance/godigit-payment-status`, {
            state: stateData,
          });
        } // Assuming response.data contains the actual data
      })
      .catch((error) => {
        console.error("Error fetching temp data:", error);
      });
    if (hasLocalSourceAndId) {
      setLocalData("source", localSource);
      setTransferDataId(id);

      // Fetch transfer data using id
      axiosInstance
        .get(`api/health/transfer-data/${id}`, {
          params: {
            source: localSource,
          },
        })
        .then((response) => {
          setTransferData(response.data);
          setPolicyNumber(response?.data?.policy_number);
          console.log("transfer data response: ", response);
        })
        .catch((error) => {
          console.error("Error fetching transfer data: ", error);
          // Handle errors related to fetching transfer data
        });
    } else {
      // Fetch temporary data to get source and id
      axiosInstance
        .get(`api/health/fetch-temp-data/${policyNumber}/`)
        .then((response) => {
          setLocalData("source", response?.data?.source);
          console.log("response?.data?.source: ", response?.data?.source);
          const transDataId = response?.data?.transfer_data_object_id;
          setTransferDataId(transDataId);
          console.log(
            "response?.data?.transfer_data_object_id: ",
            response?.data?.transfer_data_object_id,
          );

          console.log("transDataId: ", transDataId);

          if (transDataId) {
            // Fetch transfer data using id
            axios
              .get(`${domain}/api/health/transfer-data/${transDataId}`, {
                params: {
                  source: getLocalData("source"),
                },
                withCredentials: true,
              })
              .then((response) => {
                setTransferData(response.data);
                console.log("transfer data response: ", response);
              })
              .catch((error) => {
                console.error("Error fetching transfer data: ", error);
                // Handle errors related to fetching transfer data
              });
          }
        })
        .catch((error) => {
          console.error("Error fetching temporary data: ", error);
          // Handle errors related to fetching temporary data
        });
    }
  }, [localSource, id, policyNumber]);

  if (PaymentStatus === "failure") {
    console.log("PaymentStatus", PaymentStatus);
    Swal.fire({
      icon: "error",
      title: "Your Transaction has Failed!",
      text: "Click on Try Again button to proceed",
      position: "center",
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
      // showCancelButton: true,
      confirmButtonText: "Try Again",
      // showLoaderOnConfirm: true,
      // preConfirm: () => {
      //   return axios
      //     .get(`//api.github.com/users/`)
      //     .then((response) => {
      //       if (!response.ok) {
      //         throw new Error(response.statusText);
      //       }
      //       return response.json();
      //     })
      //     .catch((error) => {
      //       Swal.showValidationMessage(`Request failed: ${error}`);
      //     });
      // },
      // allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Trying again");
        const stateToPass = {
          source: getLocalData("source"),
        };
        navigate("/health-insurance", { state: stateToPass });
      }
      // else if (result.isDismissed) {
      //   console.log("New policy generate");
      //   navigate("/health-insurance");
      // }
    });
  }

  // Function to handle KYC verification and policy download
  const handleKYCVerification = () => {
    console.log("Verifying KYC");
    const domain = getDomain();
    setIsVerifyingKYC(true);

    axiosInstance
      .post(
        `api/health/go-digit/policy-and-kyc-status/${policyNumber}/`,
        {},
        {
          params: {
            source: getLocalData("source"),
            transDataId: transferDataId,
          },
        },
      )
      .then((response) => {
        setIsVerifyingKYC(false);
        console.log("kyc status response: ", response);
        if (response && response.data) {
          if (
            response?.data?.kycVerificationStatus === "DONE" &&
            (response?.data?.policyStatus === "EFFECTIVE" ||
              response?.data?.policyStatus === "COMPLETE")
          ) {
            // KYC verified and policy effective
            console.log("KYC Verified");
            Swal.fire({
              icon: "success",
              title: "Your KYC is Verified",
              text: "Please Click on OK button to proceed",
              position: "center",
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              if (result.isConfirmed) {
                console.log("Pdf Download");
                navigate(
                  `/health-insurance/policy-pdf-download/go-digit/?policyStatus=success&policyNumber=${policyNumber}`,
                  {
                    state: {
                      source: getLocalData("source"),
                      transferDataId: transferDataId,
                    },
                  },
                );
              }
            });
          } else if (
            response.data.kycVerificationStatus === "DONE" &&
            response.data.policyStatus === "UW_REFFERED"
          ) {
            // Underwriting referred, navigate to the underwriting page
            setPolicyStatus(response.data.policyStatus);
          } else if (response.data.kycVerificationStatus === "NOT_DONE") {
            // Redirect to the KYC portal
            console.log("KYC Failed");
            Swal.fire({
              icon: "error",
              title: "Your KYC has Failed",
              text: "Click on Next button to proceed",
              position: "center",
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
              confirmButtonText: "Next",
            }).then((result) => {
              if (result.isConfirmed) {
                console.log("KYC Failed");
                window.location.href = response?.data?.link;
              }
            });
          } else {
            console.log("Error in Kyc");
            alert(
              `Error ${response?.data?.Error ?? JSON.stringify(response?.data)}`,
            );
          }
        }
      })
      .catch((error) => {
        setIsVerifyingKYC(false);
        console.error("Error verifying KYC: ", error);
        Swal.fire({
          icon: "error",
          title: "Error verifying KYC",
          position: "center",
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        });
      });
  };

  const onBack = () => {
    navigate(-1);
  };

  return (
    <>
      {policyStatus === "UW_REFFERED" ? (
        <LoadingStatus
          status={5}
          data={"N/A"}
          proposerNum={"N/A"}
          policyNumber={policyNumber}
        />
      ) : (
        <div className="flex flex-col justify-center items-center">
          <div className="w-full">
            <CategoryHeader title="Health Insurance" />
          </div>

          <div className="flex flex-col justify-between items-center lg:w-3/5">
            <Container
              style={{ marginTop: 6, marginBottom: 10 }}
              maxWidth="sm md lg"
            >
              <Card
                className="card-section"
                sx={{ minWidth: 275, marginTop: 5 }}
              >
                <Box sx={{ display: "flex" }}>
                  <img
                    className="bg-white img-thumbnail rounded m-4"
                    width={100}
                    height={100}
                    src={transferData?.logo}
                  />
                  <Box style={{ margin: 16, marginTop: 30 }}>
                    <Typography>
                      <strong>{transferData?.vendor}</strong>
                    </Typography>
                    <Typography>{transferData?.product_name} </Typography>
                  </Box>
                </Box>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <Typography>Policy Premium:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        <b className="rupee_symp">&#8377;</b>{" "}
                        {transferData?.premium}{" "}
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>G.S.T:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        <b className="rupee_symp">&#8377;</b>{" "}
                        {transferData?.service_tax}{" "}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography>Total Amount:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        <b className="rupee_symp">&#8377;</b>{" "}
                        {transferData?.total_premium}{" "}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography>Policy Number:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{transferData?.policy_number} </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography>
                        <strong>PaymentStatus:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography
                        sx={
                          isNext
                            ? { color: "warning.main" }
                            : { color: "success.main" }
                        }
                      >
                        <strong> {PaymentStatus} </strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Container>
            {isVerifyingKYC && (
              <div className="flex gap-4 items-center justify-center mt-8">
                <CircularProgress size={48} sx={{ color: "red" }} />
                <Typography
                  variant="subtitle1"
                  className="text-lg font-semibold"
                >
                  Verifying KYC...
                </Typography>
              </div>
            )}
            <div className="btn-sec  position-fixed bottom-0">
              <button className="Goback_btn" onClick={onBack}>
                Go Back
              </button>
              <button
                className="submitBtn"
                onClick={handleKYCVerification}
                disabled={isVerifyingKYC}
              >
                Verify KYC
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentStatusPage;
